import {Injectable} from '@angular/core';
import {
  HttpErrorResponse,
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpParams,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpUserEvent
} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {ErrorObservable} from 'rxjs/observable/ErrorObservable';
import {Router} from '@angular/router';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import {AuthService} from 'app/services/auth.service';
import {DialogHelperService} from './dialog-helper.service';

@Injectable()
export class RequestInterceptorService implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private router: Router,
    private dialogHelper: DialogHelperService
  ) {}

  addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
    // avoiding IE caching
    let newParams = new HttpParams({ fromString: req.params.toString() });
    newParams = newParams.append('time', Date.now() + '');
    return req.clone({ setHeaders: { Authorization: token }, params: newParams });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
    if (!(req.url.includes('authUser') || req.url.includes('redirect') || req.headers.keys().some((key) => key.toLocaleLowerCase() === 'authorization'))) {
      const token = this.authService.getTokenLocal();
      if (token) {
        return next.handle(this.addToken(req, token))
          .catch(error => {
            if (error instanceof HttpErrorResponse) {
              switch ((<HttpErrorResponse>error).status) {
                case 400:
                  return this.handle400Error(error);
              }
              return this.handleOtherError(error);
            } else {
              return Observable.throw(error);
            }
          });
      }
      return next.handle(req);
    } else {
      return next.handle(req);
    }
  }

  handle400Error(error): ErrorObservable {
    if (error && (error.status === 400 || error.status === 403) && error.error && error.error.error === 'invalid_grant') {
      this.logoutUser();
    }
    return Observable.throw(error);
  }

  handleOtherError(error) {
    this.dialogHelper.showPrompt(
      'Unauthorized error',
      'Your session expired, refreshing your login...',
      'OK',
      () => {}
    );
    error.handled = true;
    this.logoutUser();
    return Observable.throw(error);
  }

  private logoutUser() {
    this.router.navigate(['login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/request-interceptor.service.ts